var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "placeholder": "Выберите дату",
            "clearable": "",
            "outlined": "",
            "rounded": "",
            "dense": "",
            "append-icon": "mdi-calendar",
            "readonly": "",
            "error-messages": _vm.errorMessages
          },
          scopedSlots: _vm._u([{
            key: "label",
            fn: function fn() {
              return [_c('span', {
                class: {
                  'required': _vm.required
                }
              }, [_vm._v(_vm._s(_vm.label))])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.computedDateFormatted,
            callback: function callback($$v) {
              _vm.computedDateFormatted = $$v;
            },
            expression: "computedDateFormatted"
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.menu,
      callback: function callback($$v) {
        _vm.menu = $$v;
      },
      expression: "menu"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "disabled": _vm.disabled,
      "locale": "ru",
      "first-day-of-week": "1",
      "no-title": ""
    },
    on: {
      "input": function input($event) {
        _vm.menu = false;
      }
    },
    model: {
      value: _vm.date,
      callback: function callback($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }